import { gql } from "lib/apolloClient";
import { classPlannerFragment } from "./ClassPlannersFragments";

export const createWeeklyPlannerTemplateMutation = gql`
  mutation createWeeklyPlannerTemplate(
    $input: CreateWeeklyPlannerTemplateInput!
  ) {
    planner {
      createWeeklyPlannerTemplate(input: $input) {
        ...classPlannerItem
      }
    }
  }
  ${classPlannerFragment.classPlannerItemFragment}
`;

export const updateWeeklyPlannerTemplateMutation = gql`
  mutation updateWeeklyPlannerTemplate(
    $input: UpdateWeeklyPlannerTemplateInput!
  ) {
    planner {
      updateWeeklyPlannerTemplate(input: $input) {
        ...classPlannerItem
      }
    }
  }
  ${classPlannerFragment.classPlannerItemFragment}
`;

export const deleteWeeklyPlannerTemplateMutation = gql`
  mutation deleteWeeklyPlannerTemplate($input: DeleteInput!) {
    planner {
      deleteWeeklyPlannerTemplate(input: $input)
    }
  }
`;

export const copyWeeklyPlannerTemplateMutation = gql`
  mutation copyWeeklyPlannerTemplate($input: CopyWeeklyPlannerTemplateInput!) {
    planner {
      copyWeeklyPlannerTemplate(input: $input) {
        ...classPlannerItem
      }
    }
  }
  ${classPlannerFragment.classPlannerItemFragment}
`;

export const createWeeklyPlannerSectionMutation = gql`
  mutation createWeeklyPlannerSection(
    $input: CreateWeeklyPlannerSectionInput!
  ) {
    planner {
      createWeeklyPlannerSection(input: $input) {
        id
        title
        startDate
        endDate
        startTime
        endTime
        colorCode
        class {
          id
          title
        }
      }
    }
  }
`;

export const deleteWeeklyPlannerSectionMutation = gql`
  mutation deleteWeeklyPlannerTemplate(
    $input: DeleteWeeklyPlanerSectionInput!
  ) {
    planner {
      deleteWeeklyPlannerSection(input: $input)
    }
  }
`;

export const updateWeeklyPlannerSectionMutation = gql`
  mutation updateWeeklyPlannerSection(
    $input: UpdateWeeklyPlannerSectionInput!
  ) {
    planner {
      updateWeeklyPlannerSection(input: $input) {
        ...weeklyPlannerSectionItem
      }
    }
  }
  ${classPlannerFragment.weeklyPlannerSectionFragment}
`;

export const updateWeeklyPlannerSectionItemsMutation = gql`
  mutation updateWeeklyPlannerSectionItems(
    $input: UpdateWeeklyPlannerSectionInput!
  ) {
    planner {
      updateWeeklyPlannerSection(input: $input) {
        ...weeklyPlannerSectionItem
      }
    }
  }
  ${classPlannerFragment.weeklyPlannerSectionItemsFragment}
`;

export const updateWeeklyPlannerSectionDescriptionMutation = gql`
  mutation updateWeeklyPlannerSectionDescription(
    $input: UpdateWeeklyPlannerSectionInput!
  ) {
    planner {
      updateWeeklyPlannerSection(input: $input) {
        id
        description
      }
    }
  }
`;

export const moveWeeklyPlannerSectionContentMutation = gql`
  mutation moveWeeklyPlannerSectionContent(
    $input: CopyWeeklyPlannerSectionContentInput!
  ) {
    planner {
      moveWeeklyPlannerSectionContent(input: $input)
    }
  }
`;

export const reorderWeeklyPlannerSectionContentMutation = gql`
  mutation reorderWeeklyPlannerSectionContent(
    $input: WeeklyPlannerSectionContentReorderInput!
  ) {
    planner {
      reorderWeeklyPlannerSectionContent(input: $input)
    }
  }
`;

export const clearWeeklyPlannerSectionContentMutation = gql`
  mutation clearWeeklyPlannerSectionContent(
    $input: ClearWeeklyPlannerSectionContentInput!
  ) {
    planner {
      clearWeeklyPlannerSectionContent(input: $input)
    }
  }
`;

export const duplicateWeeklyPlannerSectionContentMutation = gql`
  mutation duplicateWeeklyPlannerSectionContent(
    $input: CopyWeeklyPlannerSectionContentInput!
  ) {
    planner {
      duplicateWeeklyPlannerSectionContent(input: $input)
      __typename
    }
  }
`;

export const getWeeklyPlannerDownloadUrlMutation = gql`
  mutation getWeeklyPlannerDownloadUrl(
    $input: WeeklyPlannerTemplateDownloadUrlInput!
  ) {
    planner {
      weeklyPlannerTemplateDownloadUrl(input: $input) {
        url
        isSuccess
        longRunningTaskCreated
      }
      __typename
    }
  }
`;

export const importResourcesToSectionMutation = gql`
  mutation importResourcesToSection(
    $sectionId: ID!
    $resourceItems: [WeeklyPlannerSectionItemInput!]!
  ) {
    planner {
      updateWeeklyPlannerSection(
        input: { id: $sectionId, editItems: { added: $resourceItems } }
      ) {
        ...weeklyPlannerSectionItem
      }
    }
  }
  ${classPlannerFragment.weeklyPlannerSectionFragment}
`;
